export const environment = {
  apiUrl: 'https://char-codex.oxynaum.com/api'
};